var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide full",style:(`background-image: url(${_vm.slide.photo})`)},[_c('div',{staticClass:"white-bg"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.slide.details)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }